// Step changes animate: the marker fills, the tick pops in and the line to the next step draws
// from left to right. Without motion, the same changes happen at once.

.marker {
  transition:
    background-color 250ms ease,
    border-color 250ms ease,
    color 250ms ease,
    box-shadow 250ms ease;

  &[data-state="current"] {
    box-shadow: 0 0 0 4px color-mix(in srgb, var(--color-primary) 18%, transparent);
  }
}

.label {
  transition: color 250ms ease;
}

.tick {
  animation: tick-in 250ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

.line {
  position: relative;
  overflow: hidden;
  background: var(--color-border);
}

.lineFill {
  position: absolute;
  inset: 0;
  background: var(--color-primary);
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 400ms ease-out;

  &[data-filled="true"] {
    transform: scaleX(1);
  }
}

:global([dir="rtl"]) .lineFill {
  transform-origin: right center;
}

@keyframes tick-in {
  from {
    opacity: 0;
    transform: scale(0.4);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .marker,
  .label,
  .lineFill {
    transition: none;
  }

  .tick {
    animation: none;
  }
}
